import { useParams } from 'react-router-dom';
import HTMLReport from '../../Reporting/HTMLReport';

export default function PackageReport() {
    const { lotNumber } = useParams();

    let url = `api/v1/lot/${lotNumber}/packagereport`;
    let downloadName = `${lotNumber}-package-report.html`;

    return (
        <HTMLReport url={url} downloadName={downloadName}></HTMLReport>
    );
}